import React, { useEffect } from "react";
import { createRoot } from "react-dom/client";
import Modal from "../Components/base/Modal/Modal";

let hasShown = false;

export const handleSessionExpired = () => {
  if (hasShown) return;
  hasShown = true;

  const modalContainer = document.createElement("div");
  modalContainer.id = "session-expired-modal";
  document.body.appendChild(modalContainer);

  // Declare this outside component to use in redirect
  let root;

  const redirectToLogin = () => {
    if (root) root.unmount(); // ✅ unmount correctly
    if (modalContainer.parentNode) {
      document.body.removeChild(modalContainer);
    }
    localStorage.clear();
    window.location.href = "/login";
  };

  const SessionExpiredModal = () => {
    const [isOpen, setIsOpen] = React.useState(true);
    
    useEffect(() => {
      const timer = setTimeout(() => {
        redirectToLogin();
      }, 2000);
      return () => clearTimeout(timer);
    }, []);

    return (
      <Modal
        setIsOpen={setIsOpen}
        isOpen={isOpen}
        isCentered={true}
        isBtnShow={false}
        isCrossBtnShow={false}
        isStaticBackdrop={true}
        id="SessionExpired"
        // title="Session Expired"
        size='sm'
      >
        <div className="flex justify-center items-center bg-gray-100">
          {/* <Card className="max-w-md mx-auto shadow-lg rounded-xl p-6"> */}
            <div className="text-center">
              <h3 variant="h5" className="mb-4 font-bold">
                Session Expired
              </h3>

              <div className="text-gray-600 font-medium">
                Your session has expired. You will be redirected to the login
                page shortly.
              </div>
            </div>
          {/* </Card> */}
        </div>
      </Modal>
    );
  };

  root = createRoot(modalContainer);
  root.render(<SessionExpiredModal />);
};
